// Remembers the user's last search so a refresh or return visit lands back on
// their events instead of re-prompting for location and losing context.
// Stored in localStorage; safe no-ops if storage is unavailable (private mode).

import type { EventCategory } from '../types/event';
import type { LocationInfo, SortBy } from './state';

const KEY = 'irl.lastSearch.v1';

export interface SearchPrefs {
  keyword: string;
  zip: string;
  radiusMiles: number;
  location?: LocationInfo;
  categories: EventCategory[];
  sortBy: SortBy;
}

export function loadPrefs(): SearchPrefs | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<SearchPrefs>;
    if (typeof p.radiusMiles !== 'number') return null;
    return {
      keyword: typeof p.keyword === 'string' ? p.keyword : '',
      zip: typeof p.zip === 'string' ? p.zip : '',
      radiusMiles: p.radiusMiles,
      location:
        p.location && typeof p.location.lat === 'number' && typeof p.location.lng === 'number'
          ? p.location
          : undefined,
      categories: Array.isArray(p.categories) ? (p.categories as EventCategory[]) : [],
      sortBy: p.sortBy === 'nearest' ? 'nearest' : 'soonest',
    };
  } catch {
    return null;
  }
}

export function savePrefs(p: SearchPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    // storage full or blocked: remembering is best-effort, so ignore.
  }
}
